import { render, staticRenderFns } from "./LogoOres.vue?vue&type=template&id=b6385374"
import script from "./LogoOres.vue?vue&type=script&lang=js"
export * from "./LogoOres.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports